import { render, staticRenderFns } from "./recursiveSection.vue?vue&type=template&id=84324cdc&scoped=true"
import script from "./recursiveSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./recursiveSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./recursiveSection.vue?vue&type=style&index=0&id=84324cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84324cdc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxDialogSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/dialog/section.vue').default})
